import validate from "/app/node_modules/.pnpm/nuxt@3.17.4_@biomejs+biome@1.9.4_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node_49fd91a7618086e667038fea78b2db35/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@3.17.4_@biomejs+biome@1.9.4_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node_49fd91a7618086e667038fea78b2db35/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}